import { useContext } from 'react';
import ThemeContext from './ThemeContext.js';

/**
 * Returns current theme state and controls.
 *
 * @returns {{
 *   theme: 'light' | 'dark' | 'system',
 *   resolvedTheme: 'light' | 'dark',
 *   setTheme: (next: 'light' | 'dark' | 'system') => void,
 *   toggleTheme: () => void
 * }}
 */
const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default useTheme;
